import * as React from "react"
// @ts-ignore
import JHULogo from "../../images/university.small.horizontal.white.png"

export const LogoUniversity = ({ style }: { style?: React.CSSProperties }) => (
  <img id="image0" style={style} src={JHULogo} />
)
